import type { ApplicationConfig } from '@angular/core';
import { mergeApplicationConfig } from '@angular/core';

import { APP_CONFIG_BASE } from './app.config.base';

const appConfig: ApplicationConfig = {
  providers: [],
};

export const APP_CONFIG = mergeApplicationConfig(APP_CONFIG_BASE, appConfig);
